'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidShareAlt = function IoAndroidShareAlt(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 26.9c2.7 0 4.8 2.2 4.8 4.8s-2.1 4.9-4.8 4.9-4.8-2.2-4.8-4.9c0-0.4 0-0.8 0.1-1.1l-11.9-6.8c-0.9 0.8-2.1 1.3-3.4 1.3-2.7 0-5-2.3-5-5s2.2-5 4.9-5c1.3 0 2.5 0.4 3.5 1.3l11.8-6.8c-0.1-0.4-0.2-0.8-0.2-1.2 0-2.7 2.3-5 5-5s5 2.3 5 5-2.3 5-5 5c-1.3 0-2.5-0.4-3.4-1.3l-11.8 6.8c0 0.4 0.1 0.8 0.1 1.2s-0.1 0.8-0.1 1.1l11.9 6.9c0.9-0.8 2-1.2 3.3-1.2z' })
        )
    );
};

exports.default = IoAndroidShareAlt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-share-alt.js
// module id = 2142
// module chunks = 0